import { useMemo } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { ArcheLayout } from '../../../components/ArcheLayout';
import { useAuth } from '@/auth/hooks/useAuth';
import { LearnAboutFiasResourcesPage } from './LearnAboutFiasResourcesPage';
import { AdminDocumentsPage } from './AdminDocumentsPage';

export function LearnAboutFiasArchePage() {
  const { user } = useAuth();
  const isAdmin = useMemo(() => user?.roles?.includes('admin') ?? false, [user?.roles]);

  return (
    <ArcheLayout>
      <Routes>
        <Route path="/" element={<LearnAboutFiasResourcesPage />} />
        <Route
          path="/admin"
          element={isAdmin ? <AdminDocumentsPage /> : <Navigate to="/" replace />}
        />
      </Routes>
    </ArcheLayout>
  );
}
